import { lazy } from 'react';
import * as routePath from '../route-path';

const CartPage = lazy(() => import('components/Pages/CartPage'));
const CheckoutPage = lazy(() => import('components/Pages/CheckoutPage'));

export const cartRoutes = [
  {
    path: routePath.CART,
    component: CartPage,
    exact: true,
  },
  {
    path: routePath.CHECKOUT,
    component: CheckoutPage,
    exact: true,
  },
];
